import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopOrderDetails from "../../../components/Orders/Details/index";

const ShopOrderDetailsPage = () => {
  return (
    <MainLayout>
      <ShopOrderDetails />
    </MainLayout>
  );
};

export default ShopOrderDetailsPage;
